import React from 'react';
import { ChevronRight } from 'lucide-react';

const CryptoList = () => {
  const cryptos = [
    {
      name: "Bitcoin",
      symbol: "BTC",
      price: "€91,872",
      change: "-0.11%",
      icon: "₿",
      iconClass: "bg-orange-100 text-orange-600",
      path: "M 0,15 L 10,10 L 20,18 L 30,12 L 40,20 L 50,8 L 60,15 L 70,5 L 80,12 L 90,8 L 100,15"
    },
    {
      name: "Ethereum",
      symbol: "ETH",
      price: "€3,139.8",
      change: "-1.45%",
      icon: "Ξ",
      iconClass: "bg-blue-100 text-blue-600",
      path: "M 0,12 L 10,15 L 20,10 L 30,18 L 40,12 L 50,15 L 60,8 L 70,15 L 80,10 L 90,18 L 100,20"
    },
    {
      name: "Cardano",
      symbol: "ADA",
      price: "€0.9203",
      change: "-5.55%",
      icon: "⟡",
      iconClass: "bg-blue-100 text-blue-600",
      path: "M 0,8 L 10,12 L 20,10 L 30,15 L 40,12 L 50,18 L 60,15 L 70,20 L 80,18 L 90,22 L 100,25"
    },
    {
      name: "XRP",
      symbol: "XRP",
      price: "€2.4187",
      change: "-1.74%",
      icon: "✕",
      iconClass: "bg-gray-100 text-gray-600",
      path: "M 0,10 L 10,15 L 20,12 L 30,18 L 40,15 L 50,20 L 60,18 L 70,22 L 80,20 L 90,25 L 100,28"
    },
    {
      name: "Sui",
      symbol: "SUI",
      price: "€4.4448",
      change: "-5.62%",
      icon: "S",
      iconClass: "bg-blue-100 text-blue-600",
      path: "M 0,12 L 10,18 L 20,15 L 30,20 L 40,18 L 50,22 L 60,20 L 70,25 L 80,22 L 90,28 L 100,30"
    }
  ];

  return (
    <div className="max-md:px-4">
      <div className="w-full bg-white rounded-2xl shadow-sm border border-gray-100">
        {/* Desktop Header */}
        <div className="hidden md:grid grid-cols-4 px-6 py-4 border-b border-gray-100">
          <div className="text-gray-500">Asset</div>
          <div className="text-gray-500">Price</div>
          <div className="text-gray-500">Change (24h)</div>
          <div className="text-gray-500">Chart</div>
        </div>

        {/* Crypto List */}
        <div className="divide-y divide-gray-50">
          {cryptos.map((crypto, index) => (
            <div key={index} className="grid grid-cols-3 md:grid-cols-4 px-4 md:px-6 py-4 hover:bg-gray-50">
              {/* Asset Column */}
              <div className="flex items-center gap-3">
                <div className={`w-8 h-8 rounded-full ${crypto.iconClass} flex items-center justify-center font-medium`}>
                  {crypto.icon}
                </div>
                <div>
                  <div className="font-medium">{crypto.name}</div>
                  <div className="text-sm text-gray-500">{crypto.symbol}</div>
                </div>
              </div>

              {/* Price Column */}
              <div className="flex items-center justify-end md:justify-start font-medium">
                {crypto.price}
              </div>

              {/* Change Column - Hidden on Mobile */}
              <div className="hidden md:flex items-center">
                <span className="px-2 py-1 text-sm text-red-700 bg-red-50 rounded">
                  {crypto.change}
                </span>
              </div>

              {/* Chart Column */}
              <div className="flex items-center justify-end">
                <div className="w-20 md:w-24 h-8">
                  <svg
                    viewBox="0 0 100 30"
                    className="w-full h-full"
                    preserveAspectRatio="none"
                  >
                    <path
                      d={crypto.path}
                      fill="none"
                      stroke="#ef4444"
                      strokeWidth="2"
                    />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-100 text-center">
          <a href="#" className="inline-flex items-center text-blue-600 hover:text-blue-700">
            View all 372 assets
            <ChevronRight className="w-4 h-4 ml-1" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default CryptoList;